import { render, staticRenderFns } from "./Coordianates.vue?vue&type=template&id=1243a2cc&"
import script from "./Coordianates.vue?vue&type=script&lang=ts&"
export * from "./Coordianates.vue?vue&type=script&lang=ts&"
import style0 from "./Coordianates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports